export const CHAT_V2_EXPLORE_NEXT_FALLBACK_EMOJI = '✨';

const normalizeChatV2TopicText = (value) => {
    if (typeof value === 'string') {
        return value.trim();
    }

    if (value && typeof value === 'object' && typeof value.text === 'string') {
        return value.text.trim();
    }

    return '';
};

export const normalizeChatV2TopicKey = (value) => normalizeChatV2TopicText(value)
    .normalize('NFKC')
    .replace(/[‘’`]/g, "'")
    .replace(/[“”]/g, '"')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

const normalizeChatV2Suggestion = (suggestion) => {
    if (!suggestion || typeof suggestion !== 'object') {
        return null;
    }

    const text = normalizeChatV2TopicText(suggestion);
    if (!text) {
        return null;
    }

    const emoji = typeof suggestion.emoji === 'string' ? suggestion.emoji.trim() : '';

    return {
        text,
        emoji: emoji || CHAT_V2_EXPLORE_NEXT_FALLBACK_EMOJI,
    };
};

export const resolveChatV2ExploreNextSuggestions = ({
    exploreNextSuggestions,
    exploreNextTopics,
} = {}) => {
    const rawSuggestions = Array.isArray(exploreNextSuggestions) ? exploreNextSuggestions : [];
    const rawTopics = Array.isArray(exploreNextTopics) ? exploreNextTopics : [];
    const hasLegacyTopics = rawTopics.some((topic) => Boolean(normalizeChatV2TopicText(topic)));

    if (hasLegacyTopics) {
        return rawTopics.map((topic, index) => {
            const text = normalizeChatV2TopicText(topic);
            if (!text) {
                return null;
            }

            const suggestion = normalizeChatV2Suggestion(rawSuggestions[index]);
            if (!suggestion || suggestion.text !== text) {
                return {
                    text,
                    emoji: CHAT_V2_EXPLORE_NEXT_FALLBACK_EMOJI,
                };
            }

            return suggestion;
        }).filter(Boolean);
    }

    return rawSuggestions.map(normalizeChatV2Suggestion).filter(Boolean);
};

export const dedupeChatV2ExploreNextSuggestions = (suggestions) => {
    const seenTopicKeys = new Set();

    return suggestions.filter((suggestion) => {
        const topicKey = normalizeChatV2TopicKey(suggestion);

        if (!topicKey || seenTopicKeys.has(topicKey)) {
            return false;
        }

        seenTopicKeys.add(topicKey);
        return true;
    });
};

export const getVisibleChatV2ExploreNextSuggestions = ({
    exploreNextSuggestions,
    exploreNextTopics,
    exploredTopicKeys,
} = {}) => {
    const normalizedExploredTopicKeys = exploredTopicKeys instanceof Set ? exploredTopicKeys : new Set();
    const suggestions = resolveChatV2ExploreNextSuggestions({
        exploreNextSuggestions,
        exploreNextTopics,
    });

    return dedupeChatV2ExploreNextSuggestions(suggestions).filter(
        (suggestion) => !normalizedExploredTopicKeys.has(normalizeChatV2TopicKey(suggestion))
    );
};
